import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { VoleiProtocol } from '../models/voleiprotocol';

var httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
  providedIn: 'root'
})
export class VoleiProtocolService {
  private url = 'api/voleiprotocol';
  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.url = baseUrl + this.url;
  }

  getToken(): string {
    var tokenJson = JSON.parse(localStorage.getItem('currentUser') || '');
    return tokenJson.token;
  }

  getById(id: number): Observable<any> {
    const apiurl = `${this.url}/${id}`;
    return this.http.get<any>(apiurl);
  }

  get(): Observable<any> {
    const apiurl = `${this.url}`;
    return this.http.get<any>(apiurl);
  }

  post(voleiProtocol: VoleiProtocol): Observable<any> {
    const apiurl = `${this.url}`;
    return this.http.post<VoleiProtocol>(apiurl, voleiProtocol, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getToken()}`,
      },
    });
  }

  put(id: number, voleiProtocol: VoleiProtocol): Observable<any> {
    const apiurl = `${this.url}/${id}`;
    return this.http.put<VoleiProtocol>(apiurl, voleiProtocol, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getToken()}`,
      },
    });
  }

  delete(id: number): Observable<any> {
    const apiurl = `${this.url}/${id}`;
    return this.http.delete<any>(apiurl, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getToken()}`,
      },
    });
  }

}
